var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30320",
    "data-name": "Group 30320",
    transform: "translate(-139 -442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35095",
    "data-name": "Path 35095",
    d: "M23.811,17.5H16.378V25h7.432ZM22.324,1V4H10.432V1H7.459V4H5.973A2.973,2.973,0,0,0,3.015,7L3,28a2.986,2.986,0,0,0,2.973,3H26.784a3,3,0,0,0,2.973-3V7a3,3,0,0,0-2.973-3H25.3V1Zm4.459,27H5.973V11.5H26.784Z",
    transform: "translate(138 441)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30319",
    "data-name": "Group 30319",
    transform: "translate(-40 36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30317",
    "data-name": "Group 30317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30316",
    "data-name": "Group 30316",
    transform: "translate(67 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30314",
    "data-name": "Group 30314",
    transform: "translate(21 -1693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30277",
    "data-name": "Group 30277",
    transform: "translate(-6 -35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30691",
    "data-name": "Group 30691",
    transform: "translate(-14991 24105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30688",
    "data-name": "Group 30688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30685",
    "data-name": "Group 30685",
    transform: "translate(33 58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30682",
    "data-name": "Group 30682"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30659",
    "data-name": "Group 30659",
    transform: "translate(-829 1055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30559",
    "data-name": "Group 30559"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16223",
    "data-name": "Rectangle 16223",
    width: 30,
    height: 30,
    transform: "translate(15884 -23085)",
    fill: "none"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_30315",
    "data-name": "Group 30315",
    transform: "translate(-3 184)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14557",
    "data-name": "Rectangle 14557",
    width: 30,
    height: 30,
    transform: "translate(115 221)",
    fill: "none"
  }))))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.4da0dfab.svg";
export { ForwardRef as ReactComponent };